import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import _ from 'lodash'

import './MediaFilter.scss'

import { general } from '../../../../constants'

class MediaFilter extends Component {
  static defaultProps = {
    lists: [],
    debounceDelay: 500, // Default 500ms delay
    isDownloadCenter: false
  }

  static propTypes = {
    ctrlHandleFilterChange: PropTypes.func,
    debounceDelay: PropTypes.number,
    isDownloadCenter: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.debounceTimer = null
    this.state = {
      mediaTypes: this.buildMediaTypes()
    }
  }

  buildMediaTypes = () => {
    const { t, isDownloadCenter } = this.props

    if (isDownloadCenter) {
      return [
        { label: t('all'), value: general.ALL, selected: true },
        { label: t('v3:Metamaze'), value: 'maze', selected: false },
        { label: t('v4:skill_journey'), value: 'skill', selected: false }
      ]
    }

    return [
      { label: t('all'), value: general.ALL, selected: true },
      { label: t('media:video'), value: general.VIDEO, selected: false },
      {
        label: t('media:image'),
        value: `${general.IMAGE},${general.PEXEL_IMAGE}`,
        selected: false
      },
      { label: t('media:audio'), value: general.AUDIO, selected: false },
      { label: t('media:gif'), value: general.GIF, selected: false },
      { label: t('v4:pdf'), value: general.PDF, selected: false },
      { label: t('v4:doc'), value: general.DOC, selected: false },
      { label: t('v4:ppt'), value: general.PPT, selected: false },
      { label: t('v4:txt'), value: general.TEXT, selected: false },
      { label: t('v2:ar_assets'), value: general.ARIMAGE, selected: false },
      { label: t('v5:shorts'), value: 'SHORTS', selected: false },
      { label: 'AR', value: 'ARIMAGE', selected: false }
    ]
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isDownloadCenter !== this.props.isDownloadCenter) {
      this.setState({ mediaTypes: this.buildMediaTypes() })
    }
  }

  componentWillUnmount() {
    // Clear timeout when component unmounts
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  generateMediaType = mediaTypes => {
    const filterMediaType = _.filter(mediaTypes, item => item.selected)
    const mediaTypeParam = _.map(filterMediaType, 'value').toString()
    this.props.ctrlHandleFilterChange(mediaTypeParam)
  }

  debouncedGenerateMediaType = mediaTypes => {
    // Clear existing timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    // Set new timer
    this.debounceTimer = setTimeout(() => {
      this.generateMediaType(mediaTypes)
    }, this.props.debounceDelay)
  }

  hangeFilterChange = (value, ind) => {
    const { mediaTypes } = this.state

    let newJSON = [...mediaTypes]

    if (newJSON[ind].value === general.ALL && value) {
      newJSON = newJSON.map(item => ({
        ...item,
        selected: item.value === general.ALL
      }))
    } else {
      newJSON[ind].selected = value

      if (!newJSON.find(item => item.selected)) {
        newJSON[0].selected = true
      } else {
        newJSON[0].selected = false
      }
    }

    // Update state immediately for UI responsiveness
    this.setState({
      mediaTypes: newJSON
    })

    // Debounce the API call
    this.debouncedGenerateMediaType(newJSON)
  }

  render() {
    const { mediaTypes } = this.state
    return (
      <div className="filter-media-wrap">
        <div className="filter-media">
          {mediaTypes &&
            mediaTypes.map((item, ind) => (
              <label className="filtermedia-wrapper" key={ind}>
                <input
                  name="checkbox"
                  type="checkbox"
                  checked={item.selected}
                  onChange={e => this.hangeFilterChange(e.target.checked, ind)}
                />
                <span className="checkmark" data-label={item.label}>
                  {item.label}
                </span>
              </label>
            ))}
        </div>
      </div>
    )
  }
}

export default withTranslation('media')(MediaFilter)
